
export default class PasswordEditForm {

    async init(): Promise<void> {
        await this.addButtonEvent()
    }

    async clearPasswordFields(): Promise<void> {
        ([...document.querySelectorAll<HTMLInputElement>('.password-fields input[type="password"]')]).forEach((item) => {
            item.value = '';
        })
    }

    async addButtonEvent(): Promise<void> {
        document.querySelector<HTMLElement>('.show-password-fields')?.addEventListener('click', this.togglePasswowordFields)
    }

    async togglePasswowordFields(): Promise<void> {
        document.querySelector<HTMLElement>('.password-fields')?.classList.toggle('hidden')

    }
} 